import React, {Component} from 'react';
import {Input} from 'reactstrap';
import Checkbox from "../../../shared/forms/Checkbox";
import './LogFieldCard.scss';

class LogFieldCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fields: [],
      pullTylerCADData: props.initialValues.pullTylerCADData || false,
      pullIcsCADData: props.initialValues.pullIcsCADData || false,
      pullCmpdCADData: props.initialValues.pullCmpdCADData || false,
      pullLenexaCADData: props.initialValues.pullLenexaCADData || false,
      groupBy: props.initialValues.groupBy,
      formTitle: ''
    };
  }

  get formTitle() {
    if (this.props.initialValues && this.props.initialValues.form_title && this.state.formTitle == '') {
      return this.props.initialValues.form_title
    }

    return this.state.formTitle;
  }

  get initialValues() {
    return this.props.initialValues && this.props.initialValues.fields ? this.props.initialValues.fields : [];
  }

  get formFields() {
    if (this.initialValues.length > 0 && this.state.fields.length == 0) {
      return this.initialValues;
    }

    return this.state.fields;
  }

  getFiledTypeLabel(field) {
    if (field.isNumber) {
      return 'number input';
    }
    else if (field.type == 'boolean') {
      return 'checkbox input';
    }

    return `${field.type} input`;
  }

  addClick(fieldType){
    this.setState(prevState => ({
    	fields: [...this.formFields, {
        type: fieldType == 'number' ? 'text' : fieldType,
        label: '',
        value: 'value',
        optionLabel: 'label',
        options: fieldType == 'select' ? [{value: '', label: ''}] : [],
        required: false,
        isNumber: fieldType == 'number' ? true : false
      }]
    }))
  }

  addOptionClick(inputIndex, optionIndex){
    let newOption = {
      label: '',
      value: ''
    }

    let fields = [...this.formFields];
    fields[inputIndex] = {
      ...fields[inputIndex],
      options: [
        ...fields[inputIndex].options.slice(0, optionIndex + 1),
        newOption,
        ...fields[inputIndex].options.slice(optionIndex + 1),
        // ...fields[inputIndex].options,

      ]
    };
    this.setState({ fields });
  }

  handleChange(i, e) {
    const { name, value } = e.target;
    let fields = [...this.formFields];
    fields[i] = {
      ...fields[i],
      [name]: value
    };
    this.setState({ fields });
  }

  handleScoreChange(inputIndex, e) {
    const { value } = e.target;
    let fields = [...this.formFields];

    fields[inputIndex] = {
      ...fields[inputIndex],
      score: value
    };

    this.setState({ fields });
  }

  handleOptionChange(inputIndex, optionIndex, e) {
    const { value } = e.target;

    let newOption = {
      label: value,
      value: value.toLowerCase().replace(' ', '_')
    }

    let editedOption = {
      ...this.formFields[inputIndex].options[optionIndex],
      ...newOption
    }

    let fields = [...this.formFields];

    let inputOptions = fields[inputIndex].options;
    inputOptions[optionIndex] = editedOption;

    fields[inputIndex] = {
      ...fields[inputIndex],
      options: [
        ...inputOptions
      ]
    };
    this.setState({ fields });
  }

  handleFormTitleChange(e) {
    this.setState({
      formTitle: e.target.value
    });
  }

  handleCheckbox(e, i) {
    let fields = [...this.formFields];
    fields[i] = {
      ...fields[i],
      required: e.target.checked
    };
    this.setState({ fields });
  }
  handleSorted(e, i) {
    let fields = [...this.formFields];
    fields[i] = {
      ...fields[i],
      sorted: e.target.checked
    };
    this.setState({ fields });
  }

  handleGroupBy(e, i) {
    let groupBy = this.state.groupBy;
    if(!Array.isArray(this.state.groupBy)) {
      groupBy = [this.state.groupBy]
    }

    if(e.target.checked) {
      this.setState({ groupBy: [...groupBy, i] });
    } else {
      this.setState({ groupBy: groupBy.filter(gb => gb !== i) });
    }
  }

  removeClick(i){
    let fields = [...this.formFields];
    fields.splice(i, 1);
    this.setState({ fields });
  }

  removeOptionsClick(inputIndex, optionIndex){
    let fields = [...this.formFields];
    fields[inputIndex].options.splice(optionIndex, 1)
    this.setState({ fields });
  }

  handleSubmit() {
    this.props.onSave({
      fields: this.formFields,
      form_title: this.formTitle,
      groupBy: this.state.groupBy,
      pullTylerCADData: this.state.pullTylerCADData,
      pullIcsCADData: this.state.pullIcsCADData,
      pullCmpdCADData: this.state.pullCmpdCADData,
      pullLenexaCADData: this.state.pullLenexaCADData,
    });
  }

  isGroupBySelected(i) {
    if(Array.isArray(this.state.groupBy)) {
      return this.state.groupBy.includes(i)
    } else {
      return i === this.state.groupBy
    }
  }

  isSorted(sorted) {
    return sorted !== false;
  }

  render() {
    return (
      <div className="call-log-field">
        <div className="simple-inputs-container">
          <button className="button primary small" onClick={() => this.addClick('text')}>
            Input Text
          </button>
          <button className="button primary small" onClick={() => this.addClick('textarea')}>
            Text area
          </button>
          <button className="button primary small" onClick={() => this.addClick('number')}>
            Input Number
          </button>
          <button className="button primary small" onClick={() => this.addClick('boolean')}>
            Checkbox
          </button>
          <button className="button primary small" onClick={() => this.addClick('select')}>
            Select
          </button>
          <button className="button primary small" onClick={() => this.addClick('time')}>
            Time field
          </button>
          <button className="button primary small" onClick={() => this.addClick('score')}>
            Score field
          </button>
        </div>

        <div className="form-title">
          <div className="field-config-container">
            <div className="label-container">
              <label className="input-type">
                Connect with Tyler CAD
              </label>
            </div>
            <div className="input-conatiner">
              <Checkbox
                label="Pull automatic CAD data"
                checked={this.state.pullTylerCADData}
                onChange={e => this.setState({pullTylerCADData: e.target.checked})}
              />
            </div>
          </div>
          <div className="field-config-container">
            <div className="label-container">
              <label className="input-type">
                Connect with ICS CAD
              </label>
            </div>
            <div className="input-conatiner">
              <Checkbox
                label="Pull automatic CAD data"
                checked={this.state.pullIcsCADData}
                onChange={e => this.setState({pullIcsCADData: e.target.checked})}
              />
            </div>
          </div>
          <div className="field-config-container">
            <div className="label-container">
              <label className="input-type">
                Connect with CMPD CAD
              </label>
            </div>
            <div className="input-conatiner">
              <Checkbox
                label="Pull automatic CAD data"
                checked={this.state.pullCmpdCADData}
                onChange={e => this.setState({pullCmpdCADData: e.target.checked})}
              />
            </div>
          </div>
          <div className="field-config-container">
            <div className="label-container">
              <label className="input-type">
                Connect with Lenexa CAD
              </label>
            </div>
            <div className="input-conatiner">
              <Checkbox
                label="Pull automatic CAD data"
                checked={this.state.pullLenexaCADData}
                onChange={e => this.setState({pullLenexaCADData: e.target.checked})}
              />
            </div>
          </div>
        </div>

        <div className="form-title">
          <div className="field-config-container">
            <div className="label-container">
              <label className="input-type">
                Form Title
              </label>
            </div>

            <div className="input-conatiner">
              <Input
                name="form-title"
                onChange={this.handleFormTitleChange.bind(this)}
                placeholder="Form Title"
                type="text"
                value={this.formTitle}
              />
            </div>
          </div>
        </div>

        {this.formFields.map((el, i) => (
            <div key={i} className="field-config-container">
              <div className="label-container">
                <label className="input-type">
                  {this.getFiledTypeLabel(el)}
                </label>
              </div>

              <div className="input-conatiner">
                <Input
                  name="label"
                  onChange={this.handleChange.bind(this, i)}
                  placeholder="Input Field Label"
                  type="text"
                  value={el.label || ''}
                />

                {el.type != 'boolean' &&
                  <Checkbox checked={el.required}
                    onChange={e => this.handleCheckbox(e, i)} label="Is Required"/>
                }
                {el.type == 'select' &&
                  <Checkbox checked={this.isSorted(el.sorted)}
                    onChange={e => this.handleSorted(e, i)} label="Is Sorted"/>
                }
                {el.type == 'select' &&
                  <Checkbox checked={this.isGroupBySelected(i)}
                    onChange={e => this.handleGroupBy(e, i)} label="Group By"/>
                }
                {el.type == 'boolean' &&
                  <label className="checkbox"></label>
                }

                <button className="button danger small" type="button" onClick={this.removeClick.bind(this, i)} >
                  <i className="fa fa-trash"/>
                </button>
              </div>
              {el.type == 'score' && (
                  <div>
                    <div><h6>Maximum score</h6></div>
                    <div>
                      <Input
                          name="label"
                          onChange={this.handleScoreChange.bind(this, i)}
                          placeholder="Maximum score"
                          type="text"
                          value={this.formFields[i].score || ''}
                      />
                    </div>
                  </div>
              )}

              {el.type == 'select' &&
                <div className="select-options">
                  <h6>Add Select Options</h6>

                  {this.formFields[i].options.map((option, j) => (
                    <div key={`${i}${j}`} className="select-options-container">
                      <Input
                        name="value"
                        onChange={this.handleOptionChange.bind(this, i, j)}
                        placeholder="Value"
                        type="text"
                        value={option.label || ''}
                      />

                      <div className="delete-container">
                        <button className="button danger small" type="button" onClick={this.removeOptionsClick.bind(this, i, j)} >
                          <i className="fa fa-trash"/>
                        </button>
                        <button className="button secondary small" type="button" onClick={this.addOptionClick.bind(this, i, j)} >
                          <i className="fa fa-plus"/>
                        </button>
                      </div>
                    </div>
                    ))
                  }

                  {/*<button className="button primary small" onClick={() => this.addOptionClick(i)}>*/}
                  {/*  Add Option*/}
                  {/*</button>*/}
                </div>
              }
            </div>
          ))
        }

        <button className="button primary large log-field-save" type="button" onClick={this.handleSubmit.bind(this)} >
          Save
        </button>
      </div>
    )
  }

}

export default LogFieldCard;
